import {extendTailwindMerge} from 'tailwind-merge';

/**
 * tailwind-merge, eingestellt auf den Klassen-Praefix des apex-Themes.
 *
 * ⚠️ Der Praefix MUSS hier stehen. Ohne ihn erkennt tailwind-merge `tw:p-2` nicht als
 * Tailwind-Klasse und loest Konflikte nicht mehr auf: eine von aussen uebergebene Klasse
 * wuerde die der Komponente nicht ersetzen, beide blieben stehen, und es entschiede die
 * Reihenfolge im CSS statt der Aufruf.
 *
 * Hintergrund: die Modal-Bundles laufen seit 2026-09-16 OHNE Shadow DOM und nutzen damit
 * das CSS des Themes — und das ist mit `prefix(tw)` gebaut.
 */
export const twMerge = extendTailwindMerge({prefix: 'tw'});
